import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.75, delay, ease: EASE }}
        className={className}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
    <p
        className={`font-mono2 text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold ${className}`}
    >
        {children}
    </p>
);

export const SectionHeading = ({ eyebrow, title, text, align = "left" }) => {
    const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
    return (
        <div className={`flex flex-col gap-5 ${alignCls}`}>
            {eyebrow && (
                <Reveal>
                    <Eyebrow>{eyebrow}</Eyebrow>
                </Reveal>
            )}
            <Reveal delay={0.08}>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-ink max-w-3xl leading-[1.15]">
                    {title}
                </h2>
            </Reveal>
            {text && (
                <Reveal delay={0.16}>
                    <p className="text-base sm:text-lg text-ink2 leading-relaxed max-w-2xl">{text}</p>
                </Reveal>
            )}
        </div>
    );
};
